<template>
  <div class="contact_down">
    <div class="box">
      <img src="@/assets/contactpic/down-1.jpg" alt="Box 1" />
      <p>{{ $t("contactDownText9") }}</p>
      <span>{{ $t("contactDownText1") }}</span>
      <span>{{ $t("contactDownText2") }}</span>
      <span>{{ $t("contactDownText3") }}</span>
      <span>{{ $t("contactDownText8") }}</span>
    </div>
    <div class="box">
      <img src="@/assets/contactpic/down-2.jpg" alt="Box 2" />
      <p>{{ $t("contactDownText10") }}</p>
      <span>{{ $t("contactDownText4") }}</span>
      <span>{{ $t("contactDownText5") }}</span>
      <span>{{ $t("contactDownText6") }}</span>
    </div>
    <div class="box">
      <img src="@/assets/contactpic/down-3.jpg" alt="Box 3" />
      <p>{{ $t("contactDownText11") }}</p>
      <span>{{ $t("contactDownText7") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactDown",
};
</script>

<style scoped>
.contact_down {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 80vw;
  justify-items: center;
  margin: 0 auto;
  margin-top: 5vw;
}

.box {
  display: grid;
  grid-template-rows: auto auto auto auto;
  gap: 0.5rem;
  align-items: center;
  justify-items: center;
  text-align: center;
  padding: 2rem;
}

.box img {
  width: 150px;
  height: auto;
}

.box span {
  text-align: left;
  width: 100%;
}

.box p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/contact/contactItem/ContactDown.vue